<ng-container *ngIf="loading; else viewPanel">
  <div fxLayout="row" fxLayoutAlign="center center" class="loader-section margin-top-8">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewPanel>
  <div class="title-section">
    <h1 class="text-center font-lg font-bold">{{ content.title }}</h1>
    <p class="font-sm text-center sparro-grey-800">{{ content.desc }}</p>
  </div>
  <ng-container *ngIf="content.medias && content.medias.length > 0">
    <ng-container *ngFor="let media_file of content.medias">
      <div class="media">
        <ng-container *ngIf="media_file.media_type === 'FILE'; else embedType">
          <uni-project-image [project_media]="media_file"></uni-project-image>
        </ng-container>
        <ng-template #embedType>
          <uni-project-embed [project_media]="media_file"></uni-project-embed>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
